<template>
  <div id="wrapper">
    <div class="contentBox" id="pageScrollId">
      <!-- <Breadcrumb class="breadcrumb" :lastBread="pageData.name"></Breadcrumb> -->
      <div class="routerNameBox">
        <div class="routerItem">
          <router-link to="/mall" class="name"> 首页 </router-link>
          <span class="namePre">></span>
        </div>
        <div class="routerItem">
          <router-link v-if="isAllCar" class="name" to="/seller/mallCar">全线车系</router-link>
          <router-link v-else class="name" to="/seller/malljp">奇瑞精选</router-link>
          <span class="namePre">></span>
        </div>
        <div class="routerItem">
          <span class="name">{{ commodityList[0] && commodityList[0].name }}</span>
        </div>
      </div>
      <!-- 商品列表 -->
      <div class="commodityBox">
        <OneCommodityEdit
          v-for="(item, index) in commodityList"
          :commodityList="commodityList"
          :itemData="item"
          :defaultDealerId="defaultdealerId"
          @skuData="skuData(item, $event)"
          @computeMoney="computeMoney"
          @getdealerId="getdealerId"
          :key="index"
        ></OneCommodityEdit>
      </div>
      <!-- 操作按钮 -->
      <div class="actionBox">
        <span class="oneLabel"
          >为您节省:<span class="value">￥{{ saveMoney | currency('', 2) }}</span></span
        >
        <div class="line"></div>
        <span class="twoLabel">合计:</span>
        <span class="threeLabel">￥{{ totalMoney | currency('', 2) }}</span>
        <el-button :loading="loading" class="submitBtn" @click="buyNow">立即购买</el-button>
        <!-- <div class="submitBtn" v-loading.fullscreen.lock="loading" @click="buyNow">立即购买</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import OneCommodityEdit from './components/oneCommodityEdit'
import getData from '@api/details'
export default {
  components: { OneCommodityEdit },
  data() {
    return {
      // 是否是整车
      isAllCar: false,
      loading: false,
      // 经销商id
      dealerId: '',
      defaultdealerId: '', // 上一页面传递的经销商id
      skuIdOfChecked: '', // 商品详情页面选中的sku
      // 合计多少钱
      totalMoney: 0,
      // 省多少钱
      saveMoney: 0,

      pageData: {
        name: '奇瑞汽车'
      },
      commodityList: [
        // {
        //   name: '主商品名称',
        //   price: '9.98万',
        //   deposit: '99.00',
        //   checked: true,
        //   url: 'https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3130125737,4291579555&fm=26&gp=0.jpg',
        //   config: [
        //     {
        //       label: '动力',
        //       value: '',
        //       options: ['1.5TCL-6MT', '1.6T-5MT']
        //     },
        //     {
        //       label: '车型',
        //       value: '',
        //       options: ['五座版精英型1', '五座版精英型2', '五座版精英型3', '五座版精英型4']
        //     },
        //     {
        //       label: '经销商'
        //     },
        //     {
        //       label: '数量',
        //       num: 1,
        //       status: true
        //     }
        //   ]
        // },
        // {
        //   name: '搭配商品名称',
        //   subName: '这是一个好商品',
        //   price: '9.98万',
        //   deposit: '99.00',
        //   checked: false,
        //   url: 'https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3130125737,4291579555&fm=26&gp=0.jpg',
        //   config: [
        //     {
        //       label: '动力',
        //       value: '',
        //       options: ['1.5TCL-6MT', '1.6T-5MT']
        //     },
        //     {
        //       label: '车型',
        //       value: '',
        //       options: ['五座版精英型1', '五座版精英型2', '五座版精英型3']
        //     },
        //     {
        //       label: '经销商'
        //     },
        //     {
        //       label: '数量',
        //       num: 1,
        //       status: false
        //     }
        //   ]
        // },
        // {
        //   name: '搭配商品名称',
        //   subName: '这是一个好商品',
        //   price: '9.98万',
        //   deposit: '99.00',
        //   checked: true,
        //   url: 'https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3130125737,4291579555&fm=26&gp=0.jpg',
        //   config: [
        //     {
        //       label: '动力',
        //       value: '',
        //       options: ['1.5TCL-6MT', '1.6T-5MT']
        //     },
        //     {
        //       label: '车型',
        //       value: '',
        //       options: ['五座版精英型1', '五座版精英型2', '五座版精英型3', '五座版精英型4']
        //     },
        //     {
        //       label: '经销商'
        //     },
        //     {
        //       label: '数量',
        //       num: 1,
        //       status: true
        //     }
        //   ]
        // }
      ]
    }
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    /**
     * 获得选择的经销商id
     */
    getdealerId(id) {
      this.dealerId = id
    },
    /**
     * 立即购买
     */
    buyNow() {
      const itemToOrderList = []
      let groupId = ''
      let canCommit = true
      this.commodityList.forEach((one) => {
        groupId = one.groupId
        // 选择的商品或者是主商品才要添加购买
        if (one.sign === 'main' || one.checked) {
          let item = {}
          // 只有主商品才有活动id和code
          if (one.sign === 'main') {
            item.activityCode = one.detail.activityItemInfoDto.activityInfoDto.activityCode
            item.activityId = one.detail.activityItemInfoDto.activityInfoDto.id
          }
          // 主商品且是整车才有经销商
          item.dealerId = one.sign === 'main' && one.detail.type === 0 ? this.dealerId : ''

          item.itemId = one.detail.itemId ? one.detail.itemId : one.detail.id
          // 获得数量
          let buyNum = 0
          one.config.forEach((o) => {
            if (o.label === '数量') {
              buyNum = o.num
            }
          })
          item.quantity = buyNum
          item.skuId = one.skuId
          itemToOrderList.push(item)
          if (!(one.skuId && one.skuId !== '')) {
            canCommit = false
          }
        }
      })
      if (!canCommit) {
        this.$feedback('请选择商品的规格')
        return
      }
      const data = {
        itemToOrderList: itemToOrderList,
        // orderType: 1,
        // payType: 1,
        orderChannel: 0,
        // cartIds: carIds,
        groupId,
        terminal: 1,
        vmId: 1
        // ladderIndex: ladderIndex
      }
      this.loading = true
      getData
        .goBuy(data)
        .then(
          (res) => {
            if (res.status === 200) {
              this.$feedback.success('下单成功！')
              // this.placeOrderDelete(selectList)
              // this.cartItems.length -= this.checkedItems.length
              // this.$store.commit('getCartNum', [...this.cartItems, ...this.offShelf, ...this.sellout].length)
              this.isSubmit = true
              this.$router.push({
                name: 'order-confirm',
                params: { orderId: res.data }
              })
            } else {
              document.getElementById('pageScrollId').scrollIntoView()
              if (res.message === 'trade.buy.exist.unpaid.order') {
                this.$feedback('您有订单未支付')
              } else {
                this.$feedback(res.message)
              }
            }
            this.loading = false
          },
          (res) => {
            document.getElementById('pageScrollId').scrollIntoView()
            res.message !== 'Request failed with status code 401' && this.$feedback(res.message)
            this.loading = false
          }
        )
        .catch(() => {
          document.getElementById('pageScrollId').scrollIntoView()
          this.loading = false
        })
    },
    /**
     * 计算总价格
     */
    computeMoney() {
      this.totalMoney = 0
      let nativeMoney = 0
      let totalMoneyOfNotAllCar = 0
      this.commodityList.forEach((item) => {
        // 选中了才计算价格 或者 是主商品且不是整车
        // if (item.checked || (item.sign === 'main' && !this.isAllCar)) {
        // 所有商品都要算钱
        if (item.checked || item.sign === 'main') {
          // 获得数量
          const num2 = item.config.filter((o) => o.label === '数量')[0].num
          this.totalMoney += Number(item.price ? item.price : 0) * Number(num2)
        }
        // 是主商品且不是整车  和  是搭配商品且选中了  这两种情况参加计算
        if ((item.sign === 'main' && !this.isAllCar) || (item.sign === 'sub' && item.checked)) {
          // 获得数量
          const num = item.config.filter((o) => o.label === '数量')[0].num
          totalMoneyOfNotAllCar += Number(item.price ? item.price : 0) * Number(num)
          nativeMoney += Number(isNaN(item.nativePrice) ? '' : item.nativePrice) * Number(num)
        }
      })
      this.saveMoney = nativeMoney - totalMoneyOfNotAllCar
    },
    /**
     * 获得sku的操作回调
     */
    skuData(item, data) {},
    /**
     * @descripttion: 初始化数据（从store中拿到套餐数据以及当前选中的套餐）
     * @Author: lujing
     * @Date: 2021-04-19 18:09:47
     * @param {void}
     * @return {void}
     */
    init() {
      // 获得当前选择的套餐数据
      if (this.$store.state.commodityDetail && this.$store.state.commodityDetail.length >= 1) {
      } else {
        this.$router.go(-1)
        return
      }
      // 获得上一页面传递过来的经销商id
      this.defaultdealerId = this.$route.query.dealerId
      this.skuIdOfChecked = this.$route.query.skuId
      const originData = this.$store.state.commodityDetail[this.$store.state.checkCollocationId]
      if (originData && originData.commoditys && originData.commoditys.length > 0) {
        this.commodityList = originData.commoditys.map((o) => {
          const options = o.commodityData.groupedSaleAttrs.map((optionItem) => {
            return {
              label: optionItem.attrKey,
              value: '',
              options: optionItem.attrVal
            }
          })
          // 商品类型 0:整车,1:备件,2:精品,3:卡券,4:维保
          if (o.commodityData && o.commodityData.type === 0) {
            this.isAllCar = true
            options.push({
              label: '经销商'
            })
          }
          return {
            name: o.name.trim(),
            subName: o.commodityData.advertise.trim(),
            detail: o.commodityData,
            checked: o.checked,
            groupId: originData.groupId,
            mode: originData.mode,
            sign: o.sign, // main-主商品 sub-搭配商品
            data: {
              groupedSaleAttrs: o.commodityData.groupedSaleAttrs,
              // 这里说明如果secondaryItemDtoList字段有值，优先从这里取值
              skus: o.commodityData.skus ? o.commodityData.skus : o.commodityData.secondaryItemDtoList
            },
            price: '0',
            limitNum: 1,
            url: o.url,
            // 主商品选中的skuid
            skuIdOfMain: o.sign === 'main' ? this.skuIdOfChecked : '',
            config: [
              ...options,
              {
                label: '数量',
                num: 1,
                status: true
              }
            ]
          }
        })
      } else {
        this.commodityList = []
        this.totalMoney = 0
        this.saveMoney = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.progress-bar {
  width: 100%;
  height: 108px;
  box-sizing: border-box;
  margin-top: 10px;
  .progress-text {
    width: 75px;
  }
  .progress-text-begin {
    width: 75px;
    color: #252525;
  }
  .progress-text:nth-of-type(2) {
    text-align: center;
  }
  .progress-text:last-of-type {
    text-align: right;
  }
  .progress-top {
    font-size: 16px;
    color: #d20c33;
    display: flex;
    justify-content: space-between;
    line-height: 24px;
  }
  .progress-center {
    margin: 7px 0px;
    position: relative;
    width: 100%;
    height: auto;
    .white-line {
      width: 4px;
      height: 12px;
      position: absolute;
      background-color: #fff;
      left: 50%;
      top: 50%;
      margin: -6px 0 0 -2px;
    }
  }
  .progress-bottom {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    color: #6c6c6c;
    line-height: 24px;
  }
}
#wrapper {
  text-align: left;
  margin: 0 auto;
  padding-bottom: 50px;
  background-color: white;
  .contentBox {
    width: 1360px;
    margin: 0 auto;
    overflow: hidden;
    .breadcrumb {
      margin-top: 41px;
      margin-bottom: 28px;
    }
    .routerNameBox {
      padding: 20px 0 28px 0;
      font-size: 16px;
      color: #777777;
      .routerItem {
        display: inline-block;
        .namePre {
          margin: 0 6px;
        }
        &:last-child {
          color: #333333;
        }
        .name {
          color: #777777;
        }
      }
    }
  }
  .actionBox {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .oneLabel {
      color: #c6001f;
      font-size: 14px;
      .value {
        font-weight: bold;
        margin-left: 5px;
      }
    }
    .line {
      width: 1px;
      height: 20px;
      background: #d4d4d4;
      margin: 0 10px;
    }
    .twoLabel {
      color: #333;
      font-size: 14px;
    }
    .threeLabel {
      color: #c6001f;
      font-size: 20px;
      font-weight: bold;
      margin: 0 20px 0 10px;
    }
    .submitBtn {
      // width: 180px;
      // height: 40px;
      // line-height: 40px;
      // text-align: center;
      // background: #c6001f;
      // color: white;
      // font-size: 16px;
      cursor: pointer;

      border: 0;
      width: 220px;
      height: 40px;
      font-size: 18px;
      background: #c6001f;
      color: #fff;
      border-radius: 0;
      position: relative;
      right: -3px;
    }
  }
}
</style>
